import { useRef, useEffect } from 'react'

export default function useInterval(callback, interval) {
  const intervalRef = useRef(null)
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const handler = (...args) => savedCallback.current(...args)

    if (interval) {
      intervalRef.current = setInterval(handler, interval)
      return () => clearInterval(intervalRef.current)
    }
  }, [interval])

  return intervalRef
}
